module.exports = __webpack_public_path__ + "img/text_01.805bf7eb.png";